export const isAlsaffronOrg = (currentUser: any) => {
  return (
    currentUser?.data?.organization?.organizationCode === 'ALSAFFRON' ||
    currentUser?.data?.organization?.parentOrganization?.organizationCode === 'ALSAFFRON'
  );
};
